import { Component } from '@angular/core';

@Component({
  selector: 'lib-capiche-api',
  imports: [],
  template: ` <p>capiche-api works!</p> `,
  styles: ``,
})
export class CapicheApiComponent {}
